import {
  Flex,
  Avatar,
  Text,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  Portal,
  Table,
  Thead,
  Th,
  Td,
  Tr,
  Tbody,
  Button,
  useMediaQuery,
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { IoIosArrowDown } from 'react-icons/io'
import { IoIosStar } from 'react-icons/io'
import { useInfoCustomer } from '../../../hooks/useInfoCustomer'
import { MeusChamadosButton } from './MeusChamadosButton'

export function User({ avatarUrl, userName }) {
  const dateNow = new Date()
  //1366 px
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)')
  //format === Quarta, 20/10/2021

  const { infoCustomer } = useInfoCustomer()

  const formattedDate = format(dateNow, 'EEEE, dd/MM/yyyy', {
    locale: ptBR,
  })

  return (
    <Popover hasArrow zIndex={99999999}>
      <PopoverTrigger>
        <Flex alignItems="center" gap={3} cursor="pointer">
          <Avatar
            //dimensões do avatar
            w="45px"
            h="45px"
            {...(isLargerThan1366 && { w: '35px', h: '35px' })}
            name={userName}
            src={avatarUrl}
            bgColor="white"
            color="#e06f60"
          />

          <Flex flexDir="column">
            <Flex gap={2} alignItems="center">
              <Text fontSize="15px" textAlign="center" fontWeight="semibold" color="gray.100" m={0}>
                {userName}
              </Text>

              <Icon as={IoIosArrowDown} color="#37F091" />
            </Flex>
            <Text fontSize="xs" color="gray.100" m={0}>
              {formattedDate}
            </Text>
          </Flex>
        </Flex>
      </PopoverTrigger>
      <Portal>
        <PopoverContent zIndex={999999999} position="relative" overflowY="hidden">
          <PopoverHeader textAlign="center">
            <PopoverArrow />
            Olá, <strong>{userName}</strong>
          </PopoverHeader>
          <PopoverBody>
            <Text textAlign="center" mb={2} pb={2} borderBottom="1px solid #E2E8F0">
              Seja bem-vindo(a) ao CRM Innovation!
            </Text>

            <Flex flexDir="column" alignItems="center" justifyContent="center">
              <Flex gap={2} alignItems="center">
                <Text fontSize="xl" fontWeight="semibold" color="#2D2D2D">
                  Seu Ranking
                </Text>
                <Icon as={IoIosStar} color="#FFD700" fontSize="25px" />
              </Flex>
              <Flex gap={2} alignItems="center">
                <Text fontSize="xl" fontWeight="semibold" color="#2D2D2D" textAlign="center">
                  {infoCustomer?.meta_ranking_mes}º lugar
                </Text>
              </Flex>
            </Flex>
            <Table>
              <Thead>
                <Tr>
                  <Th>Pedidos Mês</Th>
                  <Th>Vendas Mês</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>{infoCustomer?.pedidos_mes}</Td>
                  <Td>{infoCustomer?.vendas_mes}</Td>
                </Tr>
              </Tbody>
            </Table>
          </PopoverBody>

          <MeusChamadosButton />

          <Button
            variant="ghost"
            colorScheme="blue"
            size="sm"
            bg="red.400"
            _hover={{ color: 'black' }}
            _focus={{ boxShadow: 'none' }}
            padding="0"
            color="white"
            borderRadius="0"
            onClick={() => {
              localStorage.removeItem('authentication')
              window.location.href = '/login'
            }}
          >
            Sair
          </Button>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
